export default [
    {
      path: 'agenda-atendimentos',
      component: require('./abas/AgendaAtendimentos.vue').default,
      meta: { middleware: 'auth', controller: 'AtendimentoController' }
    },
    {
        path: 'atendimentos/:id',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'AtendimentoController' }
    },
    // {
    //     path: 'atendimentos/add',
    //     component: require('./Add').default,
    //     meta: { middleware: 'auth', controller: 'AtendimentoController' }
    // },
    {
        path: 'atendimentos/edit/:id',
        component: require('./Edit').default,
        meta: { middleware: 'auth', controller: 'AtendimentoController' },
    },
    {
        path: 'atendimentos/show/:id',
        component: require('./Show').default,
        meta: {
            middleware: 'auth',
            controller: 'AtendimentoController'
        }
    },
    {
        path: 'relatorios/atendimentos',
        component: require('./reports/Reports').default,
        redirect: 'relatorios/atendimentos/home',
        meta: { middleware: 'auth', controller: 'RelatorioAtendimentoController' },
        children: [
            {
                path: 'home',
                name: 'relatorios_home_atendimentos',
                component: require('./reports/includes/Home').default,
                meta: { middleware: 'auth', controller: 'RelatorioAtendimentoController' },
            }, 
            {
                path: 'graficos',
                name: 'graficos_atendimentos',
                component: require('./reports/includes/Graficos').default,
                meta: { middleware: 'auth', controller: 'RelatorioAtendimentoController' },
            },
            {
                path: 'pessoa',
                name: 'relatorios_atendimentos_pessoa',
                component: require('./reports/includes/AtendimentosPorPessoa').default,
                meta: { middleware: 'auth', controller: 'RelatorioAtendimentoController' },
            },
        ]
    },

    {
        path: 'meusatendimentos',
        name: 'meus_atendimentos',
        component: require('./MeusAtendimentos').default,
        meta: { middleware: 'auth', controller: 'AtendimentoController' }
    }
];


